import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/retry';

import { LazyLoadEvent, ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { SelectItem } from '../../shared/models/index';

@Injectable()
export abstract class ApiService<T> {

    protected readonly apiVersion: string = 'v1';
    protected readonly apiGroup: string = '';
	protected abstract apiName: string = '';
	protected retries = 0; //2;

	protected items: Array<T> = [];

	public getBaseUrl(action?: string, parameters?: Array<string> | string) {
		let url = '/api/' + this.apiVersion + '/' + (this.apiGroup ? this.apiGroup + '/' : '') + this.apiName;
		if(action) {
			url += '/' + action;
		}
		if(parameters) {
			parameters = (Array.isArray(parameters) ? parameters : [parameters]);
			for(let p of parameters) {
				url += '/' + p;
			}
		}
		return url;
	}

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {}

	loadItems(reload: boolean = false): Observable<Array<T>> {
		if(!reload && this.items.length > 0) {
			return  Observable.create(observer => {
				observer.next(this.items);
				observer.complete();
			});
		}
		return this.getAll().map(data => {
			this.items = data.data;
			/*for(let item of data.data) {
				console.log(item);
			}*/

			return this.items;
		});
    }

	/**
	 * getAll(parameters)
	 * Retrieve list of objects
	 */
	getAll(parameters: object = {}): Observable<getResponse<T>> {
		return this.http.post<getResponse<T>>(
			this.getBaseUrl('get'),
			parameters
		).retry(this.retries);
	}

	/**
	 * getLazy(event: LazyLoadEvent)
	 */
	getLazy(event: LazyLoadEvent, fields?: Array<string>): Observable<getResponse<T>> {
		let params: {[k: string]: any} = event;
		if(fields) {
			params.fields = fields;
		}
		return this.http.post<getResponse<T>>(
			this.getBaseUrl('get'),
			params
		).retry(this.retries);
	}

	/**
	 * getSingle(id)
	 * Retrieve single object
	 */
	getSingle(id: number): Observable<getSingleResponse<T>> {
		return this.http.get<getSingleResponse<T>>(
			this.getBaseUrl('get', id.toString())
		).retry(this.retries);
	}

	/**
	 *
	 */
	update(data: T, store: boolean = false): Observable<updateResponse<T>> {
		return this.http.post<updateResponse<T>>(
			this.getBaseUrl(store ? 'store' : 'update'),
			data
		);
	}

	/**
	 * delete(id)
	 */
	delete(id: number): Observable<deleteResponse> {
		return  Observable.create(observer => {
			this.confirmationService.confirm({
				message: this.translate.instant("Are you sure?"),
				header: this.translate.instant("Delete " + this.apiName),
				icon: 'fa fa-trash',
				accept: () => {
					this.http.delete<deleteResponse>(
						this.getBaseUrl(id.toString())
					).subscribe(response => {
						if(response.success) {
							this.messageService.add({severity: 'success', summary: this.translate.instant("Delete " + this.apiName), detail: this.translate.instant(this.apiName + " successfully deleted")});
						} else {
							let error = (response.error ? response.error : this.translate.instant("Unknown error occured"));
							this.messageService.add({severity: 'danger', summary: this.translate.instant("Delete " + this.apiName), detail: error});
						}

						observer.next(response);
						observer.complete();
					}, err => {
						observer.next({
							success: false,
							error: ''
						});
						observer.complete();
					});
				},
				reject: () => {}
			});
		});
	}

	/**
	 * delete(id)
	 */
	restore(id: number): Observable<deleteResponse> {
		return  Observable.create(observer => {
			this.confirmationService.confirm({
				message: this.translate.instant("Are you sure?"),
				header: this.translate.instant("Restore " + this.apiName),
				icon: 'fa fa-trash',
				accept: () => {
					this.http.post<deleteResponse>(
                        this.getBaseUrl(id.toString(), 'restore'), {}
					).subscribe(response => {
						if(response.success) {
							this.messageService.add({severity: 'success', summary: this.translate.instant("Restore " + this.apiName), detail: this.translate.instant(this.apiName + " successfully restored")});
						} else {
							let error = (response.error ? response.error : this.translate.instant("Unknown error occured"));
							this.messageService.add({severity: 'danger', summary: this.translate.instant("Restore " + this.apiName), detail: error});
						}

						observer.next(response);
						observer.complete();
					}, err => {
						observer.next({
							success: false,
							error: ''
						});
						observer.complete();
					});
				},
				reject: () => {}
			});
		});
    }
    
	/**
	 *
	 */
	 selectItemArray(): SelectItem[] {
		 return [];
	 }

}


export interface getResponse<T> {
	data: Array<T>;
	total: number;
}

export interface getSingleResponse<T> {
	data: T;
}

export interface updateResponse<T> {
	success: boolean;
	error?: string;
    errors?: Object;
    message?: string;
	data?: T;
}

export interface deleteResponse {
	success: boolean;
	error: string;
}
/*interface getResponse<T> {
	success: boolean;
	count: number;
	results: Array<T>;
}

interface getSingleResponse<T> {
	success: boolean;
	result: T;
}*/

/*
	/load
	/loadSingle
	/update
	/add
	/delete

*/



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/api.service.ts